import script from "./CouponsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponsPage.vue?vue&type=script&setup=true&lang=js"

import "./CouponsPage.vue?vue&type=style&index=0&id=255cb0fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255cb0fb"]])

export default __exports__